import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';

// Base interfaces for extensible components
export interface BaseOuterContainerProps {
  $desktopbackgroundcolour?: string | null | undefined;
}

export interface BaseSmallAndMediumHeaderProps {
  $isJourneySelectPage?: boolean;
}

// Completely shared components (identical across layouts)
export const Main = styled.main`
  display: block;
`;

export const DesktopLogo = styled.div`
  display: none;

  @media ${crTheme.allBreakpoints('L')} {
    display: block;
    position: absolute;
    top: 3rem;
    left: 3rem;
    z-index: 3;
  }
`;

export const ContentWrapper = styled.div`
  padding: 25px;
  @media ${crTheme.allBreakpoints('M')} {
    padding: 40px;
  }
`;

export const BackgroundImage = styled.img`
  display: none;

  @media ${crTheme.allBreakpoints('M')} {
    display: block;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    filter: blur(90px) brightness(0.6);
    object-fit: cover;
  }
`;

// Base components that can be extended
export const BaseOuterContainer = styled.div<BaseOuterContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

export const BaseInnerContainer = styled.div`
  width: 100%;
  background-color: ${crTheme.color('grey_light')};
  overflow: hidden;
  z-index: 2;
  position: relative;

  @media ${crTheme.allBreakpoints('M')} {
    background-color: ${crTheme.color('white')};
    border-radius: 16px;
  }
`;

export const BaseSmallAndMediumHeader = styled.div<BaseSmallAndMediumHeaderProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 2rem;
  width: 100%;

  @media ${crTheme.allBreakpoints('L')} {
    display: none;
  }
`;

export const BaseSecureTextAndIconDesktopWrapper = styled.div`
  display: none;
  @media ${crTheme.allBreakpoints('L')} {
    display: block;
    position: absolute;
    z-index: 3;
  }
`;
